<div class="conteneur" *ngIf="children; else loader">
  <div class="fx-direction-row fx-wrap">
    <mat-card appearance="raised" *ngFor="let child of children" class="card">
      <mat-card-header class="card-header fx-direction-row fx-between-start">
        <mat-card-title class="fx-direction-row fx-start-center">

          <mat-icon *ngIf="!permToAddPhoto" style="margin-right: 5px;">person</mat-icon>

          <div *ngIf="permToAddPhoto && child.photo" class="container-img" matTooltip="Modifier la photo"
            (click)="openDialog(child)">
            <img [src]="child.photo" class="photo-viewer">
            <div class="edit-photo">
              <mat-icon class="icon-edit-photo">edit</mat-icon>
            </div>
          </div>

          <div *ngIf="permToAddPhoto && !child.photo" class="no-photo-container" matTooltip="Ajouter une photo"
            (click)="openDialog(child)">
            <mat-icon class="icon-no-photo" color="accent">face</mat-icon>
            <div class="add-photo">
              <mat-icon class="icon-add-photo">add</mat-icon>
            </div>
          </div>

          <span>{{ child.prenom }} {{ child.nom }}</span>
        </mat-card-title>
        <button style="align-self: flex-start;" mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </mat-card-header>
      <mat-menu class="mat-menu-child" #menu="matMenu" xPosition="before">

        <button *ngFor="let formPart of formParts" mat-menu-item (click)="openForm(child.id, formPart.stepName)">
          <mat-icon color="primary">{{ readOnly ? 'visibility' : 'edit' }}</mat-icon>
          {{ formPart.label }}
        </button>

        <button mat-menu-item *ngIf="permToAddPhoto" (click)="openDialog(child)">
          <mat-icon color="primary">{{ readOnly ? 'visibility' : 'edit' }}</mat-icon>
          Photographie
        </button>

        <!-- <button mat-menu-item color="warn" *ngIf="permService.hasPermission('child_edit')"
          (click)="onDeleteClick(child)">
          <mat-icon color="warn">delete</mat-icon> {{ 'enfant.delete'|trans }}
        </button> -->

      </mat-menu>
      <mat-card-content style="margin-left: 20px;">
        <div class="child-item-content" *ngIf="child.dateNaissance"><b>Date de naissance : </b>{{
          child.dateNaissance|date:'shortDate' }}</div>
        <div class="child-item-content" *ngIf="child.age"><b>Age : </b>{{ child.age.years }} {{ child.age.years > 1 ?
          'ans' : 'an' }}
          {{ child.age.months ? 'et ' + child.age.months + ' mois' : '' }}</div>
        <div class="child-item-content" *ngIf="child.lieuNaissance"><b>Lieu de naissance : </b>{{ child.lieuNaissance }}
          ({{ child.depNaissance }})
        </div>
      </mat-card-content>
    </mat-card>

    <ng-container [ngTemplateOutlet]="addCard"></ng-container>
  </div>

  <div *ngIf="!children.length && !permToCreate">
    <h2 style="text-align: center;">{{ 'enfant.empty_list'|trans }}</h2>
  </div>
</div>

<ng-template #loader>
  <app-loader [message]="'enfant.loading_data'|trans" class="margin"></app-loader>
</ng-template>

<ng-template #addCard>
  <mat-card appearance="outlined" *ngIf="permToCreate" class="card card-add">
    <mat-card-header class="card-header fx-direction-row fx-center-center">
      <mat-card-title class="fx-direction-row fx-center-center">
        {{ 'enfant.add'|trans }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="flex:1" class="fx-direction-row fx-center-center">
      <button mat-fab color="primary" [disabled]="!addBtnUrl" [matTooltip]="'enfant.add'|trans"
        [routerLink]="addBtnUrl">
        <mat-icon>add</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>
</ng-template>